import Vue from 'vue'

// initial state
const state = () => ({
    filter: null
})

// getters
const getters = {
}

// actions
const actions = {
    filterChecklist({ commit }, filter) {
        commit('setFilterChecklist', { filter })
    }
}

// mutations
const mutations = {
    setFilterChecklist(state, { filter }) {
        Vue.set(state, 'filter', filter)
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}